
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoaurangabadcab() {



    const cardData =
    {
        keyword: 'Pune to Aurangabad Cab',
        heading: 'Meghana Cab : Pune to Aurangabad Cab',
        headingDescription: 'Meghana Cab offers Pune to Aurangabad Cab, delivering a serene, convenient, and spiritually enriching journey to the revered Ashtavinayak temples. Whether you are embarking on a pilgrimage tour, family trip, or a peaceful retreat, our clean and well-maintained cabs with experienced drivers ensure a smooth and timely ride. Choose from a variety of vehicle options—hatchbacks, sedans, SUVs, or tempo travellers—to accommodate your group size and preferences. Enjoy transparent pricing, punctual pickups, and 24/7 customer support. Book your Pune to Aurangabad Cab with Meghana Cab and immerse yourself in devotion and tranquility with comfort and ease.',


        top: 'Top Places to Visit in Aurangabad with Meghana Cab',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "A UNESCO World Heritage Site consisting of 30+ Buddhist rock-cut caves, the Ajanta Caves date from the 2nd century BCE to around 480 CE. Renowned for their exquisite mural paintings and sculptures, these caves depict Jataka tales with emotional depth and spiritual resonance, offering a mesmerizing glimpse into ancient India’s monastic life and artistic brilliance." 
  },
  {
    "title": "Ellora Caves",
    "description": "Located about 29 km from Aurangabad, the Ellora Caves are another UNESCO-listed marvel. This monolithic complex of 34 caves (Hindu, Buddhist, and Jain) carved into basalt cliffs between the 6th–10th centuries shows extraordinary rock-cut architecture—most notably the towering Kailash Temple, the largest single monolithic structure globally, reflecting religious tolerance and artistic mastery." 
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Built in 1660 by Prince Azam Shah in memory of his mother, Dilras Banu Begum, this marble mausoleum earned the nickname 'Taj of the Deccan'. Its formal Mughal gardens, fountains, and stucco marble dome echo Agra’s Taj Mahal. At 3 km from city center, it’s Aurangabad’s iconic symbol and major attraction." 
  },
  {
    "title": "Daulatabad Fort",
    "description": "Also known as Deogiri Fort, this 12th-century fortress perches atop a 200 m conical hill. Famous for its ingenious defence design—moats, narrow passages, false gateways, confusing tunnels and past crocodile-filled moats—it was once the invincible stronghold of the Yadavas, Delhi Sultanate and Ahmadnagar Sultanate, standing as a testament to medieval military engineering." 
  },
  {
    "title": "Grishneshwar Temple",
    "description": "One of Shiva’s twelve Jyotirlingas in India, the Grishneshwar Temple lies just 2.5 km from Ellora. Built in a classical South Indian style with ornate pillars and red‑stone carvings depicting Shiva and Vishnu, pilgrims flock here to touch the Shiva Linga directly, adding spiritual depth to every visit." 
  },
  {
    "title": "Aurangabad Caves",
    "description": "Within city limits lie the lesser-known Aurangabad Caves—6th‑7th century Buddhist grottoes carved into basalt. Featuring intricate Sculptures, verandahs, and chaitya halls, these caves mirror the style of Ajanta but in a more compact, serene setting perfect for a calm, historical walk-through." 
  },
  {
    "title": "Soneri Mahal",
    "description": "Literally ‘Golden Palace’, this 17th-century Mughal‑Rajput blend built by Pahad Singh is now a museum on the university campus. Its ornate façade, central staircase to decorative pavilions, and exhibition rooms richly portray regional history, coinage and manuscripts, making it an offbeat heritage stop." 
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Museum (Himayat Bagh)",
    "description": "Housed within the historic Himayat Bagh, this museum honours Maratha king Shivaji. Across six well‑curated halls, it displays photographs, weapons, armour and mementos chronicling his life and battles against Mughal domination—making it a must‑visit for history enthusiasts." 
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "description": "Named after the famed ornithologist, this city‑side lake and nature reserve draws bird‑watchers and families. Lined with trees and peaceful footpaths, it hosts local and migratory avifauna and offers boating—making it a relaxing escape within the city." 
  },
  {
    "title": "Sunheri Mahal",
    "description": "Also called the ‘Golden Palace’, this mid‑17th‑century structure built by Pahad Singh (Shah Jahan’s envoy) fuses Mughal and Rajput styles. Now a state museum on the university campus, it houses artefacts and hosts cultural events like the Ajanta‑Ellora festival—its golden facade has given it enduring charm." 
  }
],

 "services": [
  {
    "name": "Pune to Aurangabad Cab Booking",
    "description": "Book reliable cabs from Pune to Aurangabad for a smooth and comfortable travel experience. Choose from a range of vehicles and enjoy punctual service with professional drivers."
  },
  {
    "name": "One Way Taxi Pune to Aurangabad",
    "description": "Convenient one-way cab service from Pune to Aurangabad Cab with clean cars, AC options, and experienced drivers ensuring a hassle-free journey."
  },
  {
    "name": "Round Trip Cab Pune to Aurangabad",
    "description": "Plan your round trip from Pune to Aurangabad with our comfortable cabs. Flexible return options, competitive pricing, and courteous drivers."
  },
  {
    "name": "AC Sedan Pune to Aurangabad",
    "description": "Travel in style and comfort with our AC sedan service from Pune to Aurangabad. Ideal for individuals and small families seeking a premium experience."
  },
  {
    "name": "SUV Taxi Hire Pune to Aurangabad",
    "description": "Spacious and powerful SUVs available for your Pune to Aurangabad trip. Perfect for families or groups needing extra space and comfort."
  },
  {
    "name": "Online Aurangabad Cab from Pune",
    "description": "Easily book your Pune to Aurangabad cab online in minutes. Select your car, confirm your trip, and enjoy a smooth travel experience."
  },
  {
    "name": "Budget Travel Cab Pune to Aurangabad",
    "description": "Affordable cab options from Pune to Aurangabad without compromising on safety and quality. Ideal for budget-conscious travelers."
  },
  {
    "name": "Aurangabad Tour from Pune by Cab",
    "description": "Explore Aurangabad’s top attractions with our tailored cab tour packages from Pune. Enjoy sightseeing with expert local drivers."
  },
  {
    "name": "Long Drive Pune to Aurangabad Taxi",
    "description": "Enjoy a relaxing long drive from Pune to Aurangabad with our professional taxi service. Comfortable cars and friendly chauffeurs guaranteed."
  },
  {
    "name": "Private Taxi Pune to Aurangabad",
    "description": "Hire a private taxi for a peaceful and personalized journey from Pune to Aurangabad. Ideal for business or leisure trips."
  },
  {
    "name": "Chauffeur Cab Pune to Aurangabad",
    "description": "Travel with a courteous chauffeur who ensures safe and timely service between Pune and Aurangabad in a well-maintained vehicle."
  },
  {
    "name": "Pune to Aurangabad Business Cab",
    "description": "Specialized cab service for business travelers between Pune and Aurangabad. On-time pickups, executive cars, and discreet service."
  },
  {
    "name": "Family Travel Cab Pune to Aurangabad",
    "description": "Make your family trip comfortable with our family-friendly cabs from Pune to Aurangabad. Spacious cars and safe driving."
  },
  {
    "name": "Pune to Ajanta Ellora Cab",
    "description": "Visit the world-famous Ajanta and Ellora caves from Pune with our experienced cab service. Comfortable travel and guided support."
  },
  {
    "name": "Corporate Trip Pune to Aurangabad",
    "description": "Organize your corporate travel from Pune to Aurangabad with ease. Group-friendly vehicles, punctual service, and business-class comfort."
  }
],
"tableData": [
  ["Pune to Aurangabad Cab Booking", "One Way Taxi Pune to Aurangabad"],
  ["Round Trip Cab Pune to Aurangabad", "AC Sedan Pune to Aurangabad"],
  ["SUV Taxi Hire Pune to Aurangabad", "Online Aurangabad Cab from Pune"],
  ["Budget Travel Cab Pune to Aurangabad", "Aurangabad Tour from Pune by Cab"],
  ["Long Drive Pune to Aurangabad Taxi", "Private Taxi Pune to Aurangabad"],
  ["Chauffeur Cab Pune to Aurangabad", "Pune to Aurangabad Business Cab"],
  ["Family Travel Cab Pune to Aurangabad", "Pune to Ajanta Ellora Cab"],
  ["Corporate Trip Pune to Aurangabad", ""]
],








"whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Aurangabad Cab Service",
        "WhyChoosedescription": "Meghana Cab offers reliable cab services from Pune to Aurangabad, covering popular spots like Ajanta & Ellora Caves, Bibi Ka Maqbara, and more. Enjoy a smooth, comfortable ride with expert drivers and well-maintained vehicles."
    },
    {
        "WhyChooseheading": "All-Inclusive Aurangabad Tour Packages",
        "WhyChoosedescription": "Choose from one-way or round-trip packages that include sightseeing across Aurangabad. Whether you're planning a family trip or a solo getaway, we handle the route, timing, and stopovers to ensure a fulfilling travel experience."
    },
    {
        "WhyChooseheading": "Transparent Fare with No Hidden Costs",
        "WhyChoosedescription": "Our Pune to Aurangabad cab fares are budget-friendly and all-inclusive—covering fuel, tolls, taxes, and driver charges. Get complete clarity on costs upfront and choose from sedans, SUVs, or tempo travellers as per your needs."
    },
    {
        "WhyChooseheading": "Comfortable AC Cabs for Long-Distance Travel",
        "WhyChoosedescription": "Travel over 230+ km in comfort with Meghana Cab. Our fleet includes clean, air-conditioned cars perfect for long drives. Ideal for families, groups, or corporate trips, all vehicles are regularly sanitized and serviced."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Knowledge of Aurangabad Attractions",
        "WhyChoosedescription": "Our drivers are well-versed with routes to historical sites like Ellora, Daulatabad Fort, and Panchakki. They help plan your day efficiently for maximum sightseeing with minimum travel fatigue."
    },
    {
        "WhyChooseheading": "Flexible Travel Plans – One-Way or Return Trips",
        "WhyChoosedescription": "Choose one-way, same-day return, or multi-day tour plans based on your convenience. Whether it's a quick visit or a relaxed vacation, we offer complete flexibility in scheduling your Pune to Aurangabad journey."
    },
    {
        "WhyChooseheading": "24/7 Booking & On-Road Support",
        "WhyChoosedescription": "Book anytime with our round-the-clock support team. We ensure prompt cab availability and provide real-time travel assistance during your Pune to Aurangabad trip—especially helpful during weekends and tourist seasons."
    },
    {
        "WhyChooseheading": "Ideal for Sightseeing, Business Travel & Family Trips",
        "WhyChoosedescription": "Whether it’s a heritage tour, business visit, or family outing, our cabs suit all purposes. We focus on timely service, comfort, and safety—making Meghana Cab the preferred choice for Pune to Aurangabad travel."
    }
]






















    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Aurangabad with Meghana Cab?",
        answer: "You can book your Pune to Aurangabad cab by calling Meghana Cab at +91 9075462128 or through our website for a hassle-free booking experience."
    },
    {
        question: "Which vehicle options are available for the Pune to Aurangabad trip?",
        answer: "We offer a range of vehicles including comfortable sedans, spacious SUVs, and tempo travellers, suitable for individuals, families, or groups."
    },
    {
        question: "Are Meghana Cab drivers experienced with the Pune to Aurangabad route?",
        answer: "Yes, our drivers are experienced and well-acquainted with the Pune to Aurangabad highway and major sightseeing spots in and around Aurangabad."
    },
    {
        question: "Can I book a one-way cab from Pune to Aurangabad?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip cab services for your convenience."
    },
    {
        question: "Is the fare inclusive of tolls, fuel, and driver charges?",
        answer: "Our fares typically include fuel, tolls, and driver charges. Additional charges may apply for parking or extended waiting time."
    },
    {
        question: "Are the vehicles sanitized before the trip?",
        answer: "Yes, all our cabs are thoroughly sanitized before every journey to ensure passenger safety and hygiene."
    },
    {
        question: "Is the Pune to Aurangabad cab service available 24/7?",
        answer: "Yes, we offer round-the-clock cab service from Pune to Aurangabad to suit your travel schedule."
    },
    {
        question: "Can I request stops for sightseeing or meals during the trip?",
        answer: "Yes, halts can be arranged as per your request. Please mention this during booking for better planning."
    },
    {
        question: "What payment modes are accepted?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab to plan my Pune to Aurangabad journey?",
        answer: "Call us anytime at +91 9075462128 to book your cab or discuss your travel itinerary."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a smooth ride from Pune to Aurangabad with Meghana Cab. The car was clean, and the driver was courteous and punctual.”',
    },
    {
        name: 'Ms. Sneha Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service by Meghana Cab for our Pune to Aurangabad trip. We stopped at a few tourist spots and everything was well-coordinated.”',
    },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const aurangabadCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Aurangabad Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-aurangabad-cab.jpg",
  "description": "Book affordable and reliable Pune to Aurangabad taxi service with Meghana Cabs. One way and round trip cabs available for Aurangabad sightseeing, business, and pilgrimage trips.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "One Way Taxi Pune to Aurangabad",
    "Round Trip Cab Pune to Aurangabad",
    "AC Sedan Pune to Aurangabad",
    "SUV Taxi Hire Pune to Aurangabad",
    "Family Travel Cab Pune to Aurangabad",
    "Corporate Trip Pune to Aurangabad"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Aurangabad Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Taxi Pune to Aurangabad"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Pune to Aurangabad"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SUV Taxi Hire Pune to Aurangabad"
        }
      }
    ]
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Aurangabad Cab | Meghana Cabs</title>
  <meta
    name="description"
    content="Book affordable and reliable Pune to Aurangabad taxi service with Meghana Cabs. One way and round trip cabs available for Aurangabad sightseeing, business, and pilgrimage trips."
  />
  <meta
    name="keywords"
    content="Pune to Aurangabad Cab Booking, One Way Taxi Pune to Aurangabad, Round Trip Cab Pune to Aurangabad, AC Sedan Pune to Aurangabad, SUV Taxi Hire Pune to Aurangabad, Online Aurangabad Cab from Pune, Budget Travel Cab Pune to Aurangabad, Aurangabad Tour from Pune by Cab, Long Drive Pune to Aurangabad Taxi, Private Taxi Pune to Aurangabad, Chauffeur Cab Pune to Aurangabad, Pune to Aurangabad Business Cab, Family Travel Cab Pune to Aurangabad, Pune to Ajanta Ellora Cab, Corporate Trip Pune to Aurangabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(aurangabadCabSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoaurangabadcab;